<ion-content>
  <ion-grid>
    @if (mgm$ | async; as mgm;) {
      <ion-row class="ion-align-items-start">
        <ion-col class="upper-col" size="12">
          <img src="assets/icon/sharing_image.png" class="background-gradient-image" />
          <div class="upper-col__content">
            @if (mgm && mgm.head_title) {
              <app-header [pageTitle]="" (back)="backToTabs()"
              class="refer-friends-header"></app-header>
            }
          </div>
        </ion-col>
        <ion-col class="bottom-col" size="12">
          <div class="bottom-col__content" id="referFriendScroll">
          <div [class]="
              selectedLanguage == 'es' || selectedLanguage == 'fr'
                ? 'flex-wrapper-new'
                : selectedLanguage == 'de'
                ? 'flex-wrapper-de'
                : 'flex-wrapper'
            ">
              <div class="bottom-col__content__unique-code-field">
                @if (intHeadTitle) {
                  <h2 class="int-title ion-text-center" [innerHTML]="intHeadTitle | safeHtml">
                  </h2>
                }
                @if (intHeadDescription) {
                  <p class="int-description ion-text-center"
                    [innerHTML]="intHeadDescription | safeHtml">
                  </p>
                }
                <ion-button expand="block" shape="round" (click)="invite(mgm)"
                  class="purple-btn invite-btn position-relative">
                  <span>
                    {{"syndicate-setting.Share" | translate}}
                  </span>
                  <img class="button-image-position" src="assets/icon/Combined Shape.svg" alt="shareProfile" />
                </ion-button>
                <h4 class="ion-text-center int-body-quote" [innerHTML]="intData?.int_body_quote?.[selectedLanguage] | safeHtml">
                </h4>
              </div>
              <h5 class="ion-text-center int-body-qrcode-title">
                {{ intData?.int_body_qrcode_title?.[selectedLanguage] }}
              </h5>
              @if (shareUrl && !(user$ | async)?.QRCode) {
                <qrcode #parent [elementType]="elementType"
                  [qrdata]="shareUrl" [errorCorrectionLevel]="'M'" class="qrcode">
                </qrcode>
              } @else {
                <img [src]="(user$ | async)?.QRCode" alt="" class="qrcode" />
              }
              <h6 class="ion-text-center bottom-col__content__bottom-text">
                <a (click)="openReferralModal()"> {{ "refer-friend.sharing" | translate }}</a>
              </h6>
            </div>
          </div>
        </ion-col>
      </ion-row>
    }
  </ion-grid>
</ion-content>
